import { Injectable } from '@angular/core';
import { TIMEZONES } from '@y42/date-time';
import { UserEnvironmentService } from '@y42/environment';
import { UserQuery } from '@y42/user/state';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class Y42UserEnvironmentService extends UserEnvironmentService {
  constructor(private readonly userQuery: UserQuery) {
    super();
  }

  readonly timezone$ = this.userQuery.activeUser$.pipe(map(() => this.timezone));
  readonly locale$ = this.userQuery.activeUser$.pipe(map(() => this.locale));
  readonly colorScheme$ = this.userQuery.activeUser$.pipe(map(() => this.colorScheme));

  get locale(): string | null {
    return this.userQuery.getActiveUser()?.locale || null;
  }

  get colorScheme(): string | null {
    return this.userQuery.getActiveUser()?.app_theme || null;
  }

  get timezone() {
    const userTimeZone = this.userQuery.getActiveUser()?.timezone || null;
    if (this.isValidTimeZone(userTimeZone)) {
      return userTimeZone;
    } else {
      // if userTimeZone is invalid but defined
      // it means it still follows the old format,
      // which was based on offset ("+04:00")
      //
      // The if-clause can probably be removed in 6 months or so
      if (userTimeZone) {
        const negativeOffset = userTimeZone.includes('-');
        const offsetHour = userTimeZone.split(':')[0];

        if (offsetHour) {
          const offset = negativeOffset ? Number(offsetHour) * -1 : Number(offsetHour);
          return TIMEZONES.find((tz) => tz.offset === offset)?.value || null;
        }
      }

      return null;
    }
  }

  private isValidTimeZone(tz: unknown): boolean {
    try {
      if (typeof tz !== 'string') {
        return false;
      }

      // throws an error if timezone is not valid
      Intl.DateTimeFormat(undefined, { timeZone: tz });
      return true;
    } catch (error) {
      return false;
    }
  }
}
